module.exports = __webpack_public_path__ + "static/media/logo.82ccc5eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/misc/logo.png
// module id = 1031
// module chunks = 0